import { h } from "hyperapp";

export const portifoliosRenderer = ({ portifolios = [] }) => {
  const names = portifolios.map(portifolio => portifolio.name).sort();
  const tooltipText = `<ol>${names
    .map(name => `<li>${name}</li>`)
    .join("")}</ol>`;
  const text = names.join(", ");

  return (
    <span data-placement="left" data-html="true" title={tooltipText}>
      {text}
    </span>
  );
};
